import { cssTheme } from '@uds/theme-utils';
import { css } from 'linaria';

export default () => {
  return {
    tile: css`
      flex: 1;
      flex-basis: auto;
      position: relative;
      --webkit-flex-basis: 0;
      &&& ${cssTheme.breakpoints.md} {
        width: 50%;
      }
      &&& ${cssTheme.breakpoints.lg} {
        width: 100%;
      }
    `,
    root: css`
      ${cssTheme.breakpoints.md} {
        flex-direction: row;
        display: flex;
      }
      ${cssTheme.breakpoints.lg} {
        flex-direction: column;
        height: 100%;
      }
    `,
  };
};
